module.exports = __webpack_public_path__ + "static/img/banerRat.60a4074.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/iconMenu/banerRat.jpg
// module id = 1C7Z
// module chunks = 2